import React, { useEffect, useState } from 'react';
import "./ResultTwo.css";
import yellow from "../../images/yellowbadge.svg";
import redb from "../../images/red-badge.svg";
import grap from "../../images/greybadge.svg";
import pur from "../../images/purple-badge.svg";
import yel from "../../images/yellowbadge.svg";
import { END_URL, IMG_URL } from "../../config";
import axios from 'axios';

function ResultTwo({ resultRef, test_id }) {

    const [sortedBadges, setSortedBadges] = useState([]);

    console.log("test_id in ResultTwo:", test_id);

    useEffect(() => {
        fetchBadge();
    }, []);

    const fetchBadge = async () => {

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(`${END_URL}/get-badges`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            const badges = response?.data?.badge || [];

            const matched = badges.filter(b => b.test_id === test_id);
            const unmatched = badges.filter(b => b.test_id !== test_id);

            setSortedBadges([...matched, ...unmatched]);

        } catch (error) {
            console.error("Error fetching badges:", error);
        }
    };

    function getBadgeimage(index) {
        const images = [yellow, redb, grap, pur, yel];
        return images[index] || yellow;
    }

    return (
        sortedBadges?.length > 0 && (
            <div className='restwo-cont-outer' ref={resultRef}>
                <div className='restwo-cont'>
                    <div className="restwo-cont-sub">
                        <div className="restwo-titl">
                            <h5>Badges Earned</h5>
                        </div>

                        <div className="restwo-badgeDiv">
                            <div className="resttrwo-Box">

                                {sortedBadges.map((item, index) => (
                                    <div className="resttwo-bx1" key={index}>

                                        <div className="resttwo-icon-outer">
                                            <div className="resttwo-icon">
                                                <img src={`${IMG_URL}/d0/${item.blade_image}`} alt="" />
                                            </div>
                                        </div>

                                        <div className="resttwo-contn">
                                            <div className="rsttwo-im">
                                                <span>
                                                    <img src={getBadgeimage(index)} alt="" />
                                                </span>
                                                <span>{item.title}</span>
                                            </div>

                                            <p>{item.badge_description}</p>
                                        </div>

                                    </div>
                                ))}

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    );
}

export default ResultTwo;